import * as React from "react";
import FaqPageFilterComponent from "../../../components/FaqPageFilterComponent";
import { useHubx } from "../../../HubX";
import { EVENT_FAQ_OPEN_ALL, EVENT_FAQ_CLOSE_ALL } from "../../../Events";

// eslint-disable-next-line @typescript-eslint/ban-types
export type FaqPageFilterProps = {};

function FaqPageFilter() {
  const hub = useHubx();

  const handleClickExpandAll = () => {
    hub.notify(EVENT_FAQ_OPEN_ALL);
  };

  const handleClickCloseAll = () => {
    hub.notify(EVENT_FAQ_CLOSE_ALL);
  };

  return (
    <FaqPageFilterComponent
      handleClickExpandAll={handleClickExpandAll}
      handleClickCloseAll={handleClickCloseAll}
    />
  );
}

export default FaqPageFilter;
